<template>
  <div class="flatmap">
    <header-bar
      :reverse="false"
      :transparent="true"
      :title="title"
      :back-link="backLink"
    />
    <flat-map
      ref="map"
      :image-source="mapImage"
      :width="4600"
      :height="3448"
      :markers="markers"
      :debug-click="true"
      @feature-click="popupModal"
    />
    <modal-popup
      ref="modal"
      button-text="Close"
    >
      <h1 slot="header">
        {{ lastClicked ? lastClicked.name : '' }}
      </h1>
      <div slot="body">
        <div v-if="lastimage">
          <img :src="lastimage">
        </div>
        <!-- eslint-disable vue/no-v-html -->
        <div v-html="lasthtml" />
        <!-- eslint-enable -->
      </div>
      <!-- <div slot="buttons">
        <button @click="popdownModal">View All Media</button>
      </div> -->
    </modal-popup>
  </div>
</template>

<script>
import FlatMap from '../components/FlatMap.vue'
import ExhibitData from '../mixins/ExhibitData.vue'
import forOwn from 'lodash/forOwn'

import mapImage from "../assets/flyover.jpg"

import 'ol/ol.css'

export default {
    name: 'FlyoverMap',
    components: {
        FlatMap
    },
    mixins: [ExhibitData],
    props: {
      exhibitGroup: {
        type: [String,Boolean],
        default: false
      },
      title: {
        type: String,
        default: ''
      },
      backLink: {
        type: [String, Object, Boolean],
        default: false
      }
    },
    data() {
        return {
            mapImage: mapImage,
            lastClicked: null
        }
    },
    computed: {
        markers() {
            // From all exhibits, create a list of markers to be turned into OL Features
            const mrkrs = []
            if (this.exhibitsLoaded) {
              const exhibits = this.exhibitGroup ? this.$store.getters.exhibitsGrouped[this.exhibitGroup] : this.$store.getters.allExhibits
              forOwn(exhibits, (exhibit) => {
                // If there's no map_x/map_y coordinate, don't include it.
                if (!exhibit.data.map_x || !exhibit.data.map_y) {
                  return
                }
                mrkrs.push({ longitude: exhibit.data.map_x, latitude: exhibit.data.map_y, exhibitdata: exhibit })
              })
            }
            return mrkrs
        },
        lasthtml() {
          return this.lastClicked ? this.lastClicked.data.description : ''
        },
        lastimage() {
          return this.lastClicked ? this.lastClicked.data.image : false
        }
    },
    mounted() {
    },
    methods: {
        popupModal(feature) {
            this.lastClicked = feature.get('exhibitdata')
            this.$gtm.trackEvent({
              category: 'View From Above',
              action: 'Hotspot Click',
              label: this.lastClicked.name
            })
            this.$refs.modal.open()
        },
        popdownModal() {
            this.$refs.modal.close()
            this.$router.push({name: 'burle-marx-create-fly-over-exhibit', params: {exhibitslug: this.lastClicked.friendly} })
        }
    }
}
</script>

<style lang="scss" scoped>
.flatmap {
    background: black;
    @include flex-vertical;
    // /deep/ .map-wrapper {
    //     background: #a4b56e;
    // }
}
</style>